
import OpacityComponent from "../util/OpacityComponent";
import Sport from "../util/Sport";
import Sport2 from "../util/Sport2";

export default function SportsDeReadaptation(){
    return(
     <div className="w-full overflow-hidden ">
    <Sport/>
    <Sport2/>
    <OpacityComponent top="white"/>
    
    </div>)
}